import * as IoIcons from "react-icons/io";

const experience = [
  {
    id: 0,
    title: "Software Developer (Intern)",
    company: "Amazon",
    location: "Bangalore",
    style: {
      backgroundColor: "#14213D",
      color: "#E5E5E5",
    },
    arrowStyle: {
      borderRight: "7px solid #14213D",
    },
    description:
      "Worked in Prime Video Payments Team for replacing the current widget stack inside Pay Select Page. Achieved third party redirection for payment authorisation and reduced chances of customer drop off during subscription renewal. Implemented dynamic price upgradation in Prime Video’s main landing page for 23 marketplaces. Saved 20 working hours of an SDE at every price upgrade and mitigated inconsistencies resulting from manual updgrade process. Worked on migrating a service from MAWS to Native AWS, collaborating with 10+ teams for onboarding. Built CDK package from scratch enabling service and deployment stages configurations using code as an infrastructure.",
    date: "January 2023 - July 2023",
    icon: <IoIcons.IoMdChatboxes />,
    technology: [
      "https://img.shields.io/badge/Amazon%20Prime-0F79AF?style=for-the-badge&logo=amazonprime&logoColor=white",
      "https://img.shields.io/badge/java-%23ED8B00.svg?style=for-the-badge&logo=openjdk&logoColor=white",
      "https://img.shields.io/badge/typescript-%23007ACC.svg?style=for-the-badge&logo=typescript&logoColor=white",
      "https://img.shields.io/badge/AWS-%23FF9900.svg?style=for-the-badge&logo=amazon-aws&logoColor=white",
    ],
  },
  {
    id: 1,
    title: "PRISM Developer (Intern)",
    company: "Samsung Research Institute Bangalore",
    location: "Remote",
    style: {
      backgroundColor: "#FCA311",
      color: "#14213D",
    },
    arrowStyle: {
      borderRight: "7px solid #FCA311",
    },
    description:
      "Built a multi threaded data storage and retrieval solution native to the Linux Operating Environment.",
    date: "August 2021 - March 2022",
    icon: <IoIcons.IoMdChatboxes />,
    technology: [
      "https://img.shields.io/badge/Java-ED8B00?style=for-the-badge&logo=java&logoColor=white",
      "https://img.shields.io/badge/Markdown-000000?style=for-the-badge&logo=markdown&logoColor=white",
      "https://img.shields.io/badge/Microsoft_Azure-0089D6?style=for-the-badge&logo=microsoft-azure&logoColor=white",
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
    ],
  },
  {
    id: 2,
    title: "Frontend Consultant",
    company: "BezoMoney",
    location: "Remote",
    style: {
      borderTop: "solid #FCA311 5px",
      color: "#14213D",
    },
    description:
      "Built a responsive enterprise website from ground-up for BezoMoney using Next.js. Developed fluid animations using framer motion and improved the overall UI/UX of the website.",
    date: "November 2021 - December 2021",
    icon: <IoIcons.IoMdChatboxes />,
    technology: [
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
      "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white",
      "https://img.shields.io/badge/Next-black?style=for-the-badge&logo=next.js&logoColor=white",
    ],
  },
  {
    id: 3,
    title: "Software Developer (Intern)",
    company: "Acumensa Technologies Pvt. Ltd.",
    location: "Remote",
    style: {
      backgroundColor: "#14213D",
      color: "#E5E5E5",
    },
    arrowStyle: {
      borderRight: "7px solid #14213D",
    },
    description:
      "Built a micro service from scratch to handle release and return of Power banks from a charge station. Implemented QR Code scan and communication with IOT drivers using Apache Kafka. Communicated with multi-disciplinary teams of engineers, designers, producers, and clients on a daily basis.",
    date: "July 2021 - Sept 2021",
    icon: <IoIcons.IoMdChatboxes />,
    technology: [
      "https://img.shields.io/badge/Node.js-43853D?style=for-the-badge&logo=node.js&logoColor=white",
      "https://img.shields.io/badge/PostgreSQL-316192?style=for-the-badge&logo=postgresql&logoColor=white",
    ],
  },
  {
    id: 4,
    title: "Frontend Devloper",
    company: "Requestly",
    location: "Remote",
    style: {
      borderTop: "solid #14213D 5px",
      color: "#14213D",
    },
    arrowStyle: {
      borderRight: "7px solid #ffffff",
    },
    description: "",
    date: "September 2022",
    icon: <IoIcons.IoMdChatboxes />,
    technology: [
      "https://img.shields.io/badge/-AntDesign-%230170FE?style=for-the-badge&logo=ant-design&logoColor=white",
      "https://img.shields.io/badge/MongoDB-%234ea94b.svg?style=for-the-badge&logo=mongodb&logoColor=white",
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
      "https://img.shields.io/badge/git-%23F05033.svg?style=for-the-badge&logo=git&logoColor=white",
    ],
  },
  {
    id: 5,
    title: "Content Writer",
    company: "Google Developer Student Club, Amity University, Noida",
    location: "Noida",
    style: {
      borderTop: "solid #14213D 5px",
      color: "#14213D",
    },
    arrowStyle: {
      borderRight: "7px solid #ffffff",
    },
    description:
      "Evangelizing Google’s technologies as the Content Lead (Core Team) of our Google Developer Student Club Amity. Managed 20+ events with over 300+ attendees under DSC Amity. Building an unbiased and beginner-friendly community with over 300+ active members.",
    date: "August 2020 - March 2022",
    icon: <IoIcons.IoMdChatboxes />,
    technology: [],
  },
  {
    id: 6,
    title: "Lead Developer",
    company: "EquiCode",
    location: "Remote",
    style: {
      borderTop: "solid #14213D 5px",
      color: "#14213D",
    },
    arrowStyle: {
      borderRight: "7px solid #ffffff",
    },
    description:
      "Working with a team of 5+ developers to build the official website platform for EquiCode, an organization focusing on the holistic development of beginners. Helped solidify a brand direction for EquiCode that spans both content and web. Interfaced with members on a weekly basis, providing technological expertise.",
    date: "December 2020 - April 2021",
    icon: <IoIcons.IoMdChatboxes />,
    technology: [
      "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB",
    ],
  },
];

export default experience;
